module.exports = __webpack_public_path__ + "static/media/bank-bni.94fa0b82.svg";